import React from 'react'

function Tata() {
  return (
    <div>
      TATA
    </div>
  )
}

export default Tata
